export const lerp = (a, b, n) => (1 - n) * a + n * b;

export const convertRemToPx = (rem) => {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
};

export const convertVhToPx = (vh) => {
  return document.documentElement.clientHeight * (vh / 100);
};
